import React from 'react';
import { useNavigate } from 'react-router-dom';
import BrandSymbol from '../ui/BrandSymbol';
import { ResponsiveContainer, ResponsiveContent, ResponsiveFooter } from '../ui/ResponsiveLayout';

const Frame212: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/frame-140');
  };

  const handleStart = () => {
    navigate('/frame-174');
  };

  const handleSetReminder = () => {
    alert('Reminder set!');
  };

  return (
    <ResponsiveContainer background="stone">
      {/* Centered Brand Logo */}
      <div className="absolute top-8 left-1/2 transform -translate-x-1/2 z-10">
        <BrandSymbol size="3xl" showText variant="dark" />
      </div>


      <ResponsiveContent className="pt-32">
        {/* Header with introduction label and title */}
        <div className="max-w-4xl mx-auto mb-8">
          <div className="text-black/50 text-xs font-normal font-['Work_Sans'] leading-3 mb-2">
            Introduction
          </div>
          <h1 className="text-cyan-900 text-2xl sm:text-3xl font-semibold font-['Test_Domaine_Display'] leading-tight">
            Assembling your accounts
          </h1>
        </div>

        {/* Main Content */}
        <div className="max-w-4xl mx-auto">
          {/* Description */}
          <div className="mb-8">
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
              Accounting for your financial assets and debts is a major part of planning your estate. We'll start by
              building a list of your existing accounts, and connecting them to End of an Era. We'll need things like
              checking and savings accounts, investment accounts, retirement accounts, mortgages etc.
            </p>
          </div>

          {/* Reminder Banner */}
          <div className="bg-orange-100 rounded p-4 flex items-center gap-3 mb-8">
            <div className="w-3.5 h-3.5 bg-orange-400 rounded flex-shrink-0"></div>
            <div>
              <span className="text-orange-700 text-sm font-medium font-['Work_Sans']">Not ready yet? </span>
              <button 
                onClick={handleSetReminder}
                className="text-orange-700 text-sm font-medium font-['Work_Sans'] underline hover:text-orange-800"
              >
                Set a reminder to do this later →
              </button>
            </div>
          </div>
        </div>
      </ResponsiveContent>

      {/* Responsive Footer */}
      <ResponsiveFooter
        title="List Financial Accounts and Assets"
        subtitle="5-step workflow, approximately 20 minutes"
        progressPercent={20}
        onNext={handleStart}
        onBack={handleBack}
        nextText="Start →"
      />
    </ResponsiveContainer>
  );
};

export default Frame212; 